import(/* webpackMode: "eager" */ "/codebuild/output/src192025171/src/monietab-web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src192025171/src/monietab-web/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src192025171/src/monietab-web/src/components/layout/LandingPageLayout.jsx");
